import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=35bf7e3f&scoped=true&"
import script from "./fund.vue?vue&type=script&lang=js&"
export * from "./fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf7e3f",
  null
  
)

export default component.exports